import React, { useEffect, useMemo, useState } from "react";

import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Spinner,
    TabContent,
    TabPane,
    UncontrolledDropdown,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useLocation } from "react-router-dom";
import { APIClient, setAuthorization } from "../../helpers/api_helper";
import ToastAlert from "../../Components/Common/ToastAlert";
import CustomTableContainer from "../../Components/Common/CustomTableContainer";
import QuickAddJob from "./QuickAddJob";
import Select from "react-select";
import AsyncSelect from "react-select/async";

const Index = () => {
    const api = useMemo(() => new APIClient(), []);
    const locationHook = useLocation();
    setAuthorization(localStorage.getItem("token"));

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [jobToDelete, setJobToDelete] = useState(null);

    const [jobList, setJobList] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [loadingState, setLoadingState] = useState(false);
    const [maxPage, setMaxPage] = useState(1);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [searchLocationText, setSearchLocationText] = useState("");
    const [searchKeywordText, setSearchKeywordText] = useState("");
    const [searchDiffTime, setSearchDiffTime] = useState("");
    const [searchCompanyName, setSearchCompanyName] = useState("");
    const [searchDescription, setSearchDescription] = useState("");

    const [intervalIdDescription, setIntervalIdDescription] = useState(null);
    const [searchCompanyId, setSearchCompanyId] = useState(() => {
        const params = new URLSearchParams(locationHook.search);
        const fkCompany = params.get("fk_company_id");
        return fkCompany ? fkCompany : "";
    });

    const [avgRemovedDaysGlobal, setAvgRemovedDaysGlobal] = useState(null);
    const [locationsList, setLocationsList] = useState([]);
    const [keywordsList, setKeywordsList] = useState([]);

    const [columns] = useState([
        { Header: "Company Name", accessor: "company_title" },
        { Header: "Job Title", accessor: "title" },
        {
            Header: "Tags",
            accessor: "discovery_input",
            Cell: (cellProps) => {
                const discoveryInput = cellProps.row.original.discovery_input;
                if (!discoveryInput) return "-";
                
                // discovery_input Go'dan map[string]interface{} olarak geliyor
                let inputArray = [];
                
                if (Array.isArray(discoveryInput)) {
                    inputArray = discoveryInput;
                } else if (typeof discoveryInput === 'string') {
                    // String ise virgülle ayır
                    inputArray = discoveryInput.split(',').map(item => item.trim()).filter(item => item);
                } else if (typeof discoveryInput === 'object' && discoveryInput !== null) {
                    // map[string]interface{} -> Sadece keyword ve location değerlerini al
                    const values = [];
                    if (discoveryInput.keyword) {
                        values.push(String(discoveryInput.keyword));
                    }
                    if (discoveryInput.location) {
                        values.push(String(discoveryInput.location));
                    }
                    inputArray = values;
                }
                
                if (inputArray.length === 0) return "-";
                
                return (
                    <div className="d-flex flex-wrap gap-1">
                        {inputArray.map((item, index) => (
                            <span key={index} className="badge badge-soft-primary">
                                {item}
                            </span>
                        ))}
                    </div>
                );
            }
        },
        { 
            Header: "Posted Date",
            accessor: "posted_date",
            Cell: (cellProps) => {
                if (!cellProps.row.original.posted_date) return "-";
                const date = new Date(cellProps.row.original.posted_date);
                return date.toLocaleDateString('tr-TR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        { 
            Header: "Removal Date",
            accessor: "removed_date",
            Cell: (cellProps) => {
                if (!cellProps.row.original.removed_date) return "-";
                const date = new Date(cellProps.row.original.removed_date);
                return date.toLocaleDateString('tr-TR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        { 
            Header: "Duration",
            accessor: "open_duration",
            Cell: (cellProps) => {
                const postedDate = cellProps.row.original.posted_date;
                const removedDate = cellProps.row.original.removed_date;
                
                if (!postedDate) return "-";
                
                const posted = new Date(postedDate);
                const endDate = removedDate ? new Date(removedDate) : new Date();
                const diffTime = Math.abs(endDate - posted);
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                
                if (diffDays === 0) {
                    return "Today";
                } else if (diffDays === 1) {
                    return "1 day";
                } else if (diffDays < 30) {
                    return `${diffDays} days`;
                } else if (diffDays < 365) {
                    const months = Math.floor(diffDays / 30);
                    const remainingDays = diffDays % 30;
                    if (remainingDays === 0) {
                        return `${months} months`;
                    } else {
                        return `${months} months ${remainingDays} days`;
                    }
                } else {
                    const years = Math.floor(diffDays / 365);
                    const remainingDays = diffDays % 365;
                    if (remainingDays === 0) {
                        return `${years} years`;
                    } else {
                        const months = Math.floor(remainingDays / 30);
                        return `${years} years ${months} months`;
                    }
                }
            }
        },
        {
            Header: "Actions",
            Cell: (cellProps) => (
                <UncontrolledDropdown>
                    <DropdownToggle href="#" className="btn-soft-secondary btn-sm" tag="button">
                        <i className="ri-more-fill" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                                                            <DropdownItem onClick={() => viewJob(cellProps.row.original)}>
                                        <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                        View Details
                                    </DropdownItem>
                        <DropdownItem onClick={() => confirmDelete(cellProps.row.original)}>
                            <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                            Delete
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            ),
            sortable: false,
        },
    ]);

    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const toggleViewModal = () => setIsViewModalOpen(!isViewModalOpen);
    const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);

    const viewJob = (job) => {
        setSelectedJob(job);
        toggleViewModal();
    };

    const confirmDelete = (job) => {
        setJobToDelete(job);
        toggleDeleteModal();
    };

    const deleteJob = async () => {
        if (!jobToDelete) return;
        
        try {
            await api.delete(`v1/jobs/${jobToDelete.id}`);
            await getJobList();
            ToastAlert("Successfully deleted.", "success");
            toggleDeleteModal();
            setJobToDelete(null);
        } catch (error) {
            ToastAlert(error, "error");
        }
    };

    const getJobList = async () => {
        setLoadingState(true);
        try {
            let url = `v1/jobs/?page=${pageNumber}`;
            if (searchLocationText && searchLocationText.length > 0) {
                url += `&location=${encodeURIComponent(searchLocationText)}`;
            }
            if (searchKeywordText && searchKeywordText.length > 0) {
                url += `&keyword=${encodeURIComponent(searchKeywordText)}`;
            }
            if (searchDiffTime && String(searchDiffTime).length > 0) {
                url += `&diff_time=${encodeURIComponent(searchDiffTime)}`;
            }
            if (searchCompanyId && String(searchCompanyId).length > 0) {
                url += `&fk_company_id=${encodeURIComponent(searchCompanyId)}`;
            }
            if (searchCompanyName && searchCompanyName.length > 0) {
                url += `&company_name=${encodeURIComponent(searchCompanyName)}`;
            }
            if (searchDescription && searchDescription.length > 0) {
                url += `&description=${encodeURIComponent(searchDescription)}`;
            }
            const response = await api.get(url);
            // Handle new PaginationResponse structure
            if (response && response.data && Array.isArray(response.data)) {
                setJobList(response.data);
                setRowCount(response.count || 0);
                setMaxPage(response.max_page || 1);
                setNextPage(response.next);
                setPrevPage(response.prev);
            } else if (Array.isArray(response)) {
                // Fallback for old response format
                setJobList(response);
                setRowCount(response.length || 0);
                setMaxPage(Math.ceil((response.length || 0) / pageSize));
            } else if (response && Array.isArray(response.results)) {
                // Fallback for old response format
                setJobList(response.results);
                setRowCount(response.count || 0);
                setMaxPage(Math.ceil((response.count || 0) / pageSize));
            } else {
                setJobList([]);
                setRowCount(0);
                setMaxPage(1);
            }
        } catch (error) {
            ToastAlert(error, "error");
        } finally {
            setLoadingState(false);
        }
    };

    const getGlobalAvgRemovedDays = async () => {
        try {
            const res = await api.get(`v1/jobs/avg-removed-days`);
            setAvgRemovedDaysGlobal(res && res.avg_days !== undefined ? res.avg_days : null);
        } catch (e) {
            setAvgRemovedDaysGlobal(null);
        }
    };

    const getLocationsList = async () => {
        try {
            const res = await api.get(`v1/inputs/locations`);
            if (Array.isArray(res)) {
                setLocationsList(res.map(location => ({ value: location, label: location })));
            }
        } catch (e) {
            setLocationsList([]);
        }
    };

    const getKeywordsList = async () => {
        try {
            const res = await api.get(`v1/inputs/keywords`);
            if (Array.isArray(res)) {
                setKeywordsList(res.map(keyword => ({ value: keyword, label: keyword })));
            }
        } catch (e) {
            setKeywordsList([]);
        }
    };

    const searchCompanies = async (inputValue) => {
        try {
            if (!inputValue || inputValue.length < 2) {
                return [];
            }
            const res = await api.get(`v1/companies/?company_name=${encodeURIComponent(inputValue)}`);
            
            if (res && res.data && Array.isArray(res.data)) {
                return res.data.map(company => ({ 
                    value: company.name, 
                    label: company.name 
                }));
            } else if (Array.isArray(res)) {
                return res.map(company => ({ 
                    value: company.name, 
                    label: company.name 
                }));
            }
            return [];
        } catch (e) {
            return [];
        }
    };

    useEffect(() => {
        getJobList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, pageSize, searchLocationText, searchKeywordText, searchDiffTime, searchCompanyId, searchCompanyName, searchDescription]);

    useEffect(() => {
        setPageNumber(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchLocationText, searchKeywordText, searchDiffTime, searchCompanyId, searchCompanyName, searchDescription]);

    useEffect(() => {
        if (pageSize !== 20) {
            setPageNumber(1);
        }
    }, [pageSize]);

    useEffect(() => {
        const params = new URLSearchParams(locationHook.search);
        const fkCompany = params.get("fk_company_id");
        if (fkCompany) {
            setSearchCompanyId((prev) => (prev !== fkCompany ? fkCompany : prev));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationHook.search]);

    useEffect(() => {
        getGlobalAvgRemovedDays();
        getLocationsList();
        getKeywordsList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    document.title = "Job posts · Horus";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Job posts" pageTitle="Talent" />
                    <Row>
                        <Col xs={12}>
                            <div>
                                <Card>
                                    <CardBody className="border-bottom-dashed border-bottom">
                                        <div className="alert alert-info mb-0">
                                            Overall average job closure duration: <strong>{avgRemovedDaysGlobal !== null ? `${Number(avgRemovedDaysGlobal).toFixed(1)} days` : '—'}</strong>
                                        </div>
                                    </CardBody>
                                    <CardBody className="border-bottom-dashed border-bottom">
                                        <div className="d-flex align-items-center gap-2 flex-wrap w-100">
                                            <div style={{ minWidth: 240, flex: 1 }}>
                                                <Select
                                                    options={locationsList}
                                                    placeholder="Select Location"
                                                    isClearable
                                                    value={locationsList.find(option => option.value === searchLocationText) || null}
                                                    onChange={(selectedOption) => {
                                                        setSearchLocationText(selectedOption ? selectedOption.value : "");
                                                    }}
                                                />
                                            </div>
                                            <div style={{ minWidth: 240, flex: 1 }}>
                                                <Select
                                                    options={keywordsList}
                                                    placeholder="Select Keyword"
                                                    isClearable
                                                    value={keywordsList.find(option => option.value === searchKeywordText) || null}
                                                    onChange={(selectedOption) => {
                                                        setSearchKeywordText(selectedOption ? selectedOption.value : "");
                                                    }}
                                                />
                                            </div>
                                            <div className="search-box" style={{ minWidth: 240, flex: 1 }}>
                                                <Input
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    className="form-control"
                                                    placeholder="Closure Duration (days)"
                                                    value={searchDiffTime}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "" || /^\d+$/.test(value)) {
                                                            setSearchDiffTime(value);
                                                        }
                                                    }}
                                                    onKeyPress={(e) => {
                                                        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && e.key !== 'Enter') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                <i className="ri-time-line search-icon"></i>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 flex-wrap w-100 mt-3">
                                            <div style={{ minWidth: 240, flex: 1 }}>
                                                <AsyncSelect
                                                    loadOptions={searchCompanies}
                                                    placeholder="Select Company Name"
                                                    isClearable
                                                    noOptionsMessage={() => "Enter at least 2 characters"}
                                                    loadingMessage={() => "Searching..."}
                                                    value={searchCompanyName ? { value: searchCompanyName, label: searchCompanyName } : null}
                                                    onChange={(selectedOption) => {
                                                        setSearchCompanyName(selectedOption ? selectedOption.value : "");
                                                    }}
                                                />
                                            </div>
                                            <div className="search-box" style={{ minWidth: 240, flex: 1 }}>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Filter by Description"
                                                    onChange={(e) => {
                                                        setLoadingState(true);
                                                        clearTimeout(intervalIdDescription);
                                                        const newTimeoutId = setTimeout(() => {
                                                            setSearchDescription(e.target.value);
                                                        }, 300);
                                                        setIntervalIdDescription(newTimeoutId);
                                                    }}
                                                />
                                                <i className="ri-file-text-line search-icon"></i>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardBody>
                                        <TabContent className="text-muted">
                                            <TabPane>
                                                <div id="table-job-list-all" className="table-card gridjs-border-none pb-2">
                                                    {!loadingState ? (
                                                        jobList && jobList.length > 0 ? (
                                                            <CustomTableContainer
                                                                columns={columns}
                                                                data={jobList}
                                                                rowCount={rowCount}
                                                                maxPage={maxPage}
                                                                handlePageChange={setPageNumber}
                                                                handlePageSize={setPageSize}
                                                                currentPageSize={pageSize}
                                                                currentPage={pageNumber}
                                                                divClass="table-responsive mb-1"
                                                                tableClass="mb-0 align-middle table-borderless"
                                                                theadClass="table-light text-muted"
                                                            />
                                                        ) : (
                                                            <div className="py-4 text-center">
                                                                <div>
                                                                    <lord-icon
                                                                        src="https://cdn.lordicon.com/msoeawqm.json"
                                                                        trigger="loop"
                                                                        colors="primary:#405189,secondary:#0ab39c"
                                                                        style={{ width: "72px", height: "72px" }}
                                                                    ></lord-icon>
                                                                </div>
                                                                <div className="mt-4">
                                                                    <h5>No records yet. Use the quick add form to add job postings.</h5>
                                                                </div>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div className="py-4 text-center">
                                                            <Spinner color="primary" />
                                                        </div>
                                                    )}
                                                </div>
                                            </TabPane>
                                        </TabContent>
                                    </CardBody>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {isModalOpen ? (
                <QuickAddJob isModalOpen={isModalOpen} toggleModal={toggleModal} getJobList={getJobList} />
            ) : null}



            {/* Job Detay Modal */}
            <Modal isOpen={isViewModalOpen} toggle={toggleViewModal} size="lg">
                <ModalHeader toggle={toggleViewModal}>
                    Job Details
                </ModalHeader>
                <ModalBody>
                    {selectedJob && (
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">ID:</label>
                                <p>{selectedJob.id}</p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Company ID:</label>
                                <p>{selectedJob.fk_company_id}</p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Company Name:</label>
                                <p>{selectedJob.company_title || "-"}</p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Job Title:</label>
                                <p>{selectedJob.title}</p>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-bold">Posted Date:</label>
                                <p>{selectedJob.posted_date ? new Date(selectedJob.posted_date).toLocaleDateString('tr-TR') : "-"}</p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Removal Date:</label>
                                <p>{selectedJob.removed_date ? new Date(selectedJob.removed_date).toLocaleDateString('tr-TR') : "-"}</p>
                            </div>
                            <div className="col-12">
                                <label className="form-label fw-bold">Description:</label>
                                <p>{selectedJob.description || "No description available."}</p>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Silme Onay Modal */}
            <Modal isOpen={isDeleteModalOpen} toggle={toggleDeleteModal} size="sm">
                <ModalHeader toggle={toggleDeleteModal}>
                    <i className="ri-error-warning-line text-warning me-2"></i>
                    Delete Confirmation
                </ModalHeader>
                <ModalBody>
                    <p className="mb-0">
                        Are you sure you want to delete the job posting <strong>"{jobToDelete?.title}"</strong>?
                    </p>
                    <p className="text-muted small mt-2 mb-0">
                        This action cannot be undone.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleDeleteModal}>
                        Cancel
                    </Button>
                    <Button color="danger" onClick={deleteJob}>
                        <i className="ri-delete-bin-fill me-1"></i>
                        Delete
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default Index;


